// ============================================
// Premium Map Styles — IdaCab
// Ultra-premium dark & light map themes
// Used across Driver, Dispatcher & Admin dashboards
// ============================================

/**
 * Premium dark map style — sleek, minimal, Uber/InDrive-grade
 * Reduces visual noise, highlights roads, makes markers pop
 */
export const PREMIUM_DARK_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#1d2c4d' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#8ec3b9' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#1a3646' }] },
    {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#4b6878' }],
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#64779e' }],
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#4b6878' }],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#334e87' }],
    },
    {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{ color: '#023e58' }],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#283d6a' }],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6f9ba5' }],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#1d2c4d' }],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [{ color: '#023e58' }],
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#3C7680' }],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#304a7d' }],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98a5be' }],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#1d2c4d' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#2c6675' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#255763' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#b0d5ce' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#023e58' }],
    },
    {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#98a5be' }],
    },
    {
        featureType: 'transit',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#1d2c4d' }],
    },
    {
        featureType: 'transit.line',
        elementType: 'geometry.fill',
        stylers: [{ color: '#283d6a' }],
    },
    {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#3a4762' }],
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#0e1626' }],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#4e6d70' }],
    },
];

/**
 * Premium light map style — clean, minimal, professional
 * Subdued colors, clean roads, elegant POI styling
 */
export const PREMIUM_LIGHT_STYLE = [
    // Removing heavy overrides to ensure places, streets, and paths are visible and interactive.
    // Standard Google Map light style is highly optimized for readability.
];

/**
 * Returns the appropriate map style based on current theme
 */
export const getMapStyle = (isDark = false) => {
    return isDark ? PREMIUM_DARK_STYLE : PREMIUM_LIGHT_STYLE;
};

/**
 * Shared premium map options — used by all dashboards
 * Ensures consistent, interactive, jitter-free experience
 */
export const getPremiumMapOptions = (isDark = false) => ({
    disableDefaultUI: true,
    zoomControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    gestureHandling: 'greedy',
    styles: getMapStyle(isDark),
    clickableIcons: true,
    minZoom: 3,
    maxZoom: 20,
});

export default getMapStyle;
